// extracted by mini-css-extract-plugin
module.exports = {"name":"dece2e673c--name--181Bt","phone":"dece2e673c--phone--2ClHK","note":"dece2e673c--note--liGcR","button":"dece2e673c--button--2ArBf"};